import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=f8d8802e&scoped=true&"
import script from "./ButtonBlock.vue?vue&type=script&lang=ts&"
export * from "./ButtonBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&id=f8d8802e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d8802e",
  null
  
)

export default component.exports